<template>
  <general-config :id="userInfo.id" :user-type="userInfo.type"></general-config>
</template>
<script>
// import HUploader from "@/components/HUploader";
import GeneralConfig from "../../components/GeneralConfig";
import { mapGetters } from "vuex";
export default {
  components: { GeneralConfig },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    ...mapGetters(["userInfo"]),
  },
};
</script>

<style scoped>
</style>